// src/config/apiConfig.ts
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;

if (!API_BASE_URL) {
  throw new Error("Missing REACT_APP_API_BASE_URL in environment variables.");
}

export default API_BASE_URL;
